
















































import Vue from 'vue' // eslint-disable-line no-unused-vars
import ContributeModal from '@/components/modals/contribute'

export default {
  name: 'private-modal',
  components: {
    ContributeModal
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {
    date() {
      const roundedTime = this.$store.getters['time/roundedTime']
      return Vue.options.filters.moment(roundedTime, 'dddd Do')
    },
    aboutLink() {
      return window.portalLink('about-us/')
    }
  },
  methods: {
    login() {
      this.$store.dispatch('runtime/showModal', 'login')
    },
    contribute() {
      window.openLink(window.portalLink('users/contribute/'))
      setTimeout(() => this.$store.dispatch('runtime/showModal', 'login'), 3000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/private.vue